import { Component, OnInit } from '@angular/core';
import { ConnectService } from './service/connect.service';
import { Kural } from 'src/app/kural/Kural';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  kural: Kural[];
  constructor(private service: ConnectService){

  }
  ngOnInit(): void {
    this.service.getone(Math. floor(Math. random() * (1330- 1 + 1)) + 1).subscribe(
      data => {
        return this.hr(data);
      })
  }
  hr(data){
    this.kural = data;
  }
  title = 'thirukkural';
}

